import { StampFeeListReducer } from "../reducer/StampFeeListReducer";

export const reducer = StampFeeListReducer;
